// HELPERS
import { stringifyFptiProps } from '@/utils'

// CONSTANTS
import { commonModularProfileFptiProperties } from '@/constants'

export const EDIT_DESCRIPTION_PAGE_SHOWN_FPTI = {
  ...commonModularProfileFptiProperties,
  eventName: 'bp_business_description_page_shown',
}

export const EDIT_DESCRIPTION_BACK_LINK_CLICK_FPTI = stringifyFptiProps({
  ...commonModularProfileFptiProperties,
  eventName: 'bp_business_description_page_back_click',
})

export const EDIT_DESCRIPTION_PREVIEW_BUTTON_CLICK_FPTI = stringifyFptiProps({
  ...commonModularProfileFptiProperties,
  eventName: 'bp_business_description_page_preview_click',
})
